import { XMarkIcon } from "@heroicons/react/24/outline";
import * as React from "react";
import { cn } from "@/core/utils/utils";

interface FilterPillProps {
  children: React.ReactNode;
  backgroundColor?: string;
  onClear: () => void;
  className?: string;
}

export const FilterPill = React.forwardRef<HTMLDivElement, FilterPillProps>(
  ({ children, backgroundColor, onClear, className }, ref) => (
    <div
      ref={ref}
      className={cn(
        "inline-flex items-center gap-2 rounded-full px-2 py-1 text-sm font-medium",
        backgroundColor || "bg-gray-100 text-gray-800",
        className,
      )}
    >
      <span>{children}</span>
      <button
        onClick={onClear}
        className="flex h-4 w-4 items-center justify-center rounded-full hover:bg-black/10 focus:outline-none focus:ring-1 focus:ring-black/20"
        aria-label="Remove filter"
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    </div>
  ),
);

FilterPill.displayName = "FilterPill";
